
    import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
    import { namespace } from "vuex-class";
    import SureViewIcon from "@/components/SureViewIcon.vue";

    @Component({
		components: {
			"sureview-icon": SureViewIcon		
		}
	})
    export default class AreaFinderStatus extends Vue {
        @Prop(Boolean) sitesLoading: boolean;
        @Prop(String) areaSearch: string;
        @Prop(Boolean) anyVisibleSites: boolean;

        readonly noSearchResultsMessage: string = "No areas could be found matching your search."
        readonly noAreasMessage: string = "No areas could be found.";
    }
